import { Directive, HostListener, inject } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({ selector: '[submitOnEnter]' })
export class TriggerSubmitOnEnterDirective {
  private readonly ngForm = inject(FormGroupDirective);

  @HostListener('keydown.enter', ['$event.target'])
  onEnter(): void {
    this.ngForm.ngSubmit.emit(this.ngForm.value);
  }
}
